import React, {Component, Fragment} from "react"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import ClosedPollsQuery, {closedPollsQuery} from "@irati/recognition/apollo/query/ClosedPolls"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"
import Loader from "@irati/utils/services/apollo/Loading/Loader"

import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {TransitionFeed} from "../../../components/Feed"
import Poll from "../../../components/Polls/ClosedPoll/Poll"
import LoadMore from "../../../components/LoadMore"
import EmptyContent from "./Empty"

const Feed = styled(TransitionFeed)`
  margin-bottom: ${({theme}) => theme.spacing.four};
`

class ClosedPolls extends Component {
  constructor(props) {
    super(props)
    this.state = {
      variables: closedPollsQuery.variables,
      hasRefetchingError: false
    }
  }

  hasReceivedData(data) {
    return data && "closedPolls" in data && "results" in data.closedPolls && data.closedPolls.results.length > 0
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state

    if (atBottom && !hasRefetchingError && this.fetchMore) {
      this.fetchMore()
    }
  }

  fetchMore = () => {
    this.setState({
      hasRefetchingError: false
    })
    this.fetchMore().catch(() => {
      this.setState({
        hasRefetchingError: true
      })
    })
  }

  hasNextData(apollo: ApolloState<any, ClosedPollsQuery>) {
    const {results, cursor} = apollo.data.closedPolls
    const resultsLength = results?.length || 0
    return resultsLength && !!cursor && cursor !== "null"
  }

  handleNewPage = (isVisible: boolean, apollo: ApolloState<any, ClosedPollsQuery>) => {
    if (isVisible) {
      const {cursor} = apollo.data.closedPolls
      const {variables} = this.state
      if (this.hasNextData(apollo)) {
        return apollo.fetchMore({...variables, cursor})
      }
    }
  }

  render() {
    const {hasRefetchingError, variables} = this.state
    const queryProps = {...ClosedPollsQuery, variables}

    return (
      <Fragment>
        <Card tiny noBorder>
          <DisablePointerEventsOnScroll>
            <ClosedPollsQuery {...queryProps}>
              {(apollo) => {
                const {data, loading: isLoading, error, networkStatus, refetch} = apollo
                const hasData = this.hasReceivedData(data)
                const hasError = error || hasRefetchingError
                const isRefetching = networkStatus === 3
                this.fetchMore = !isLoading && this.hasNextData(apollo) ? () => apollo.fetchMore(variables) : null

                return isLoading && !isRefetching ? (
                  <Loader />
                ) : (
                  <Fragment>
                    {hasData && (
                      <Feed
                        arr={data.closedPolls.results}
                        component={({item}) => <Poll item={{poll: item, id: item.uuid}} showPublish />}
                      />
                    )}
                    {!isLoading && hasError && <LoadMore onClick={error ? () => refetch(variables) : this.fetchMore} />}
                    {isLoading && <Loader />}
                    {!isLoading && !hasError && !hasData && <EmptyContent />}
                  </Fragment>
                )
              }}
            </ClosedPollsQuery>
          </DisablePointerEventsOnScroll>
        </Card>
      </Fragment>
    )
  }
}

export default ClosedPolls
